import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/** ユーザ選択情報 */
export interface ISelectUser {
	check: string; // チェックボックス情報
	loginId: string; // ログインID
	userFamilyName: string; // ユーザ氏名(姓)
	userName: string; // ユーザ氏名(名)
	userId: string; // ユーザID
	name: string; // 氏名
	orgPath: string; // 組織名（または、グループ名）
	returnOrgPath: string; // 組織名
	homePhone: string; // 電話番号
	mainMail: string; // メインメール
	subMail: string; // サブメール
	titleName: string; // 役職
}

/** ユーザ選択情報検索条件 */
export interface ISelectUserSearchCondition {
	loginId: string;
	searchWord: string;
	userFamilyName: string;
	userName: string;
}

/**
 * ユーザ選択情報設定アクションクリエータ
 */
export const setSelectUserData = actionCreator<{
	data: ISelectUser[];
}>('SET_SELECT_USER_DATA');

/**
 * ユーザ選択画面表示カラム設定アクションクリエータ
 */
export const setSelectUserSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_SELECT_USER_SELECTED_COLUMNS');



// WEBPACK FOOTER //
// ./src/actions/user.ts